<template>
    <div class="custom-actions">

        <div>
            <label class="filter-label">Responsabile:</label>
            <select class="compensation-filter form-control" v-model="responsible_id" @change="this.getChilds">
                <option value="null">---</option>
                <option v-for="(row) in responsible"  :value="row.person_id">
                    {{ row.fullName }}
                </option>
            </select>
        </div>

        <div>
            <label class="filter-label">Collaboratore:</label>
            <select class="compensation-filter form-control" v-model="goToCollaborator" @change="gotoChild($event)">
                <option v-for="(row) in collaborators" :value="row.person_id">
                    {{ row.fullName }}
                </option>
            </select>
        </div>

    </div>
  </template>

<script>
    export default {

        data() {
            return {
                session_typology : "merit_matrix",
            }
        },

        mounted() {

            this.session_typology = this.typology_of_sesssion

            // for (const property in this.responsible) {
            //     let element = {};
            //     element.property = this.responsible[property];
            //     this.selectableResponsibles.push(element);
            // }
            //console.log(this.responsible.sort());
            let unsortResp = this.responsible;
            this.responsible_id = this.selected_responsible_id;
            this.goToCollaborator = this.person_id;
            this.collaborators = this.collaborators_for_responsible;

        },
        props: {
            collaborators_for_responsible: {
                type: Array,
                required: true
            },
            person_id: {
                type: Number,
                required: true
            },
            compensations_session:{
                type: Number,
                required: true
            },
            responsible: {
                type: Array,
                required: true
            },
            selected_responsible_id: {
                type: Number,
                required: false,
            },
            next_view :{
                type: String,
                required : true
            },
            extra_param:{
                type: String,
                required : false,
                default:''
            },
            typology_of_sesssion:{
                type: String,
                required : true,
                default:''
            },

        },
        data()  {
            return {
                action : "",
                responsible_id : null,
                selectableResponsibles: [],
                collaborators : null,
                goToCollaborator : null
            }
        },
        methods: {

            getChilds(event){
                //console.log(event.target.value);
                let responsible_id = event.target.value;
                console.log(responsible_id);

                axios.get("/people-collaborators/"+responsible_id+"/person?session_id= "+this.compensations_session+"&typology_of_session="+this.session_typology)
                    .then((response) => {

                        //console.log(response.data);
                        this.collaborators = response.data;
                        //this.qualificationsGet  = response.data;


                    });
            },
            gotoChild(event){                
                window.location.href= "/"+this.next_view+event.target.value+this.extra_param;
            },


        }
    }
</script>

<style scoped>
    .custom-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: auto;
        height: 60px;
    }
    .custom-actions div {
        margin-left: 20px;
    }
</style>
